// plugins/v-click-outside.ts
import { defineNuxtPlugin } from "#app";
import { clickOutsideDirective } from "~/directives/v-click-outside";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("click-outside", clickOutsideDirective);
});
